import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { Col } from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

import Avatar from '../Avatar';
import CurrencyConverter from '../CurrencyConverter';

import messages from '../../locale/jsonMessages';
import { photosShow } from '../../helpers/photosShow';
import { fileuploadDir } from '../../config';
import { cancellationHostData, getPriceWithDiscount } from '../../helpers/cancellationData';

import defaultPic from './large_no_image.jpeg';
import { formatTime } from '../../helpers/formatting';
import steeringIcon from '/public/SiteIcons/steeringIcon.svg';
import starIcon from '/public/SiteIcons/star.svg';
import nonRefund from '/public/SiteIcons/nonRefund.svg';
import refund from '/public/SiteIcons/refund.svg';
import Faq from '/public/SiteIcons/question.svg';

import bt from '../../components/commonStyle.css';
import s from './Cancellation.css';

const DetailsForHost = (props) => {
  const { reservationId, confirmationCode, threadId, userType, title, listId, checkIn, checkOut } = props;
  const { guests, profileId, firstName, guestEmail, hostName, picture, basePrice, delivery, guestServiceFee } = props;
  const { hostServiceFee, total, currency, cancelData, intl: { formatMessage }, initialize, discount, isSpecialPriceAverage } = props;
  const { holdeData, startTime, endTime, serviceFees, base, rates, hostServiceFeeType, hostServiceFeeValue, carType, transmission, starRatingValue } = props;
  const { promoDiscount, promoCodeType } = props;

  const [state, setState] = useState({ nonPayoutAmount: 0, refundDays: 0, earnedDays: 0, payoutAmount: 0, totalNights: 0, dayPrice: 0 });

  useEffect(() => {
    let { policyName, accomodation, guestFees, remainingNights, interval, nights, priorDays } = cancelData;

    let refundAmount = 0, nonPayoutAmount = 0, refundDays = 0, payoutAmount = 0, earnedDays = 0, subtotal = 0, updatedGuestFee = 0, updatedHostFee = 0, totalNights = 0;
    let isCleaingPrice = delivery || 0, dayPrice, priceForDays = 0, bookingSpecialPricing = [], isSpecialPriceAssigned = false, updatedPromoDiscount = 0, updatedPromoCodeType;

    let formattedStartTime = startTime ? formatTime(startTime) : null;
    let formattedEndTime = endTime ? formatTime(endTime) : null;

    holdeData.bookingSpecialPricing?.forEach(item => {
      let currentPrice = item.blockedDates ? Number(item.isSpecialPrice) : Number(basePrice);
      bookingSpecialPricing.push({ blockedDates: item, isSpecialPrice: currentPrice });
      if (item.blockedDates) isSpecialPriceAssigned = true;
    });

    if (isSpecialPriceAssigned) {
      bookingSpecialPricing.forEach(item => {
        priceForDays += Number(item.isSpecialPrice);
      });
    } else {
      priceForDays = Number(basePrice) * Number(nights);

    }

    dayPrice = getPriceWithDiscount({ basePrice: isSpecialPriceAverage || basePrice, discount, nights });

    const cancellationHostObj = cancellationHostData({
      remainingNights,
      nights,
      priceForDays,
      accomodation,
      guestServiceFee,
      guestFees,
      hostServiceFee,
      hostServiceFeeType,
      hostServiceFeeValue,
      basePrice: dayPrice,
      total,
      policyName,
      interval,
      serviceFees,
      priorDays,
      isCleaingPrice,
      base,
      rates,
      currency,
      discount,
      promoDiscount,
      promoCodeType
    });

    ({ refundAmount, nonPayoutAmount, payoutAmount, earnedDays, refundDays, updatedHostFee, updatedGuestFee, updatedPromoDiscount, updatedPromoCodeType } = cancellationHostObj);

    subtotal = total + guestServiceFee;

    const cancellationData = {
      reservationId,
      cancellationPolicy: cancelData.defaultPolicyName || cancelData.policyName,
      refundToGuest: refundAmount,
      payoutToHost: payoutAmount,
      guestServiceFee: updatedGuestFee,
      hostServiceFee: updatedHostFee,
      total: subtotal,
      currency,
      threadId,
      cancelledBy: 'owner',
      checkIn,
      checkOut,
      guests,
      hostName,
      guestName: firstName,
      listTitle: title,
      confirmationCode,
      guestEmail,
      startTime,
      endTime,
      promoDiscount: updatedPromoDiscount,
      promoCodeType: updatedPromoCodeType
    };

    totalNights = nights - refundDays;

    initialize('CancellationForm', cancellationData, true);
    setState({ nonPayoutAmount, earnedDays, refundDays, payoutAmount, totalNights, dayPrice: isSpecialPriceAverage || basePrice });
  }, []);

  const { nonPayoutAmount, refundDays, earnedDays, payoutAmount, totalNights, dayPrice } = state;

  const { policyName, defaultPolicyName, policyContent } = cancelData;

  let coverImage = holdeData?.listData?.listPhotos?.find(o => o.id == holdeData.listData.coverPhoto);
  let imagePath = photosShow(fileuploadDir);
  let path = `${imagePath}x_medium_`;
  let showImage = coverImage ? path + coverImage.name :
    (holdeData?.listData?.listPhotos?.[0]?.name ? path + holdeData.listData.listPhotos[0].name : defaultPic);

  return (
    <div>
      <Col xs={12} sm={5} md={5} lg={5}>
        <div className={cx(s.cancelRightCol, bt.commonBorderSection, bt.spaceBottom3)}>
          <div className={cx(s.bgCover, bt.spaceBottom3)}>
            <a href={`/cars/${listId}`} target="_blank">
              <div className={s.cancelBg} style={{ backgroundImage: `url(${showImage})` }}></div>
            </a>
            <div className={cx(s.profileAvatarSection, 'cancelTripAvatarSecRTL')}>
              <Avatar
                source={picture}
                height={44}
                width={44}
                title={hostName}
                className={cx(s.profileAvatar, bt.profileAvatarLinkSmall)}
                withLink
                linkClassName={cx(s.profileAvatarLink, s.profileLinkPadding)}
                profileId={profileId}
              />
            </div>
          </div>
          <div className={cx(bt.listingCardCarTypeAndTransmissionLabelFlexContainer, bt.spaceBottom1)}>
            <div className={bt.textFlow}>
              <img src={steeringIcon} className={bt.carTypeIcon} />{' '}
              <span>{carType}</span>
            </div>
            <div className={cx(bt.textFlow, bt.transmissionLabelText, 'transmissionLabelTextRtl')}>{transmission}</div>
          </div>
          <div className={cx(s.textTruncate, s.listingTitleSec)}>
            <a className={cx(s.listingTitle, bt.commonContentText, bt.fontWeightBold)} href={`/cars/${listId}`} target="_blank">
              {title}
            </a>
          </div>

          {starRatingValue > 0 && (
            <div className={bt.dFlex}>
              <img src={starIcon} className={cx(s.starIcon, 'cancelTripStarIconRTL')} />
              <span className={cx(bt.commonContentText, bt.fontWeightNormal)}>{starRatingValue}</span>
            </div>
          )}
        </div>

        <div>
          <div className={cx(s.cancelPayDetails, bt.spaceBottom3, {
            [s.hostFundSec]: payoutAmount > 0,
            [s.guestFundSec]: payoutAmount <= 0
          })}>
            {payoutAmount > 0 && (
              <>
                <div className={cx(bt.dFlex, bt.spaceBottom9)}>
                  <div className={cx(s.leftSecWidth, s.textLeft, bt.dFlex, 'textAlignRightRTL')}>
                    <img src={refund} className={cx(s.missedEarningsIcon, 'missedEarningsIconRTL')} />
                    <span className={cx(bt.commonContentText, bt.fontWeightBold)}>
                      <FormattedMessage {...messages.earningsLabel} />
                    </span>
                    <div className={s.specialPriceIcon}>
                      <span className={s.iconSection}><img src={Faq} className={cx(s.faqImage)} /></span>
                      <div className={cx(s.toolTip, s.toolTipRelativeSection, 'toolTipRelativeSectionRTL')}>
                        <FormattedMessage {...messages.hostServiceFeeTooltipText} />
                      </div>
                    </div>
                  </div>
                  <div className={cx(s.rightSecWidth, s.textRight, 'textAlignLeftRTL')}>
                    <span className={cx(bt.commonContentText, bt.fontWeightBold)}>
                      <CurrencyConverter amount={payoutAmount} from={currency} />
                    </span>
                  </div>
                </div>
                <div className={cx(bt.commonSmallText, bt.fontWeightNormal, { [bt.spaceBottom8]: nonPayoutAmount > 0 })}>
                  <span><CurrencyConverter amount={dayPrice} from={currency} /></span>
                  <span> x {totalNights} {totalNights > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span><br />
                </div>
              </>
            )}
            {(nonPayoutAmount > 0 && payoutAmount > 0) && <hr className={s.lineBg} />}
            {(refundDays > 0 && nonPayoutAmount > 0) && (
              <div>
                <div className={cx(bt.dFlex, bt.spaceBottom9)}>
                  <div className={cx(s.leftSecWidth, s.textLeft, bt.dFlex, 'textAlignRightRTL')}>
                    <img src={nonRefund} className={cx(s.missedEarningsIcon, 'missedEarningsIconRTL')} />
                    <span className={cx(bt.commonContentText, bt.fontWeightBold)}>
                      <FormattedMessage {...messages.missedEarnings} />
                    </span>
                  </div>
                  <div className={cx(s.rightSecWidth, s.textRight, 'textAlignLeftRTL')}>
                    <span className={cx(bt.commonContentText, bt.fontWeightBold, s.strikeOutLine)}>
                      <CurrencyConverter amount={nonPayoutAmount} from={currency} />
                    </span>
                  </div>
                </div>
                <div className={cx(bt.commonSmallText, bt.fontWeightNormal, bt.spaceBottom8)}>
                  <span><CurrencyConverter amount={dayPrice} from={currency} /></span>
                  <span> x {refundDays} {refundDays > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}</span><br />
                </div>
              </div>
            )}
            {nonPayoutAmount > 0 && (
              <div className={cx(s.spaceTop2)}>
                <p className={cx(bt.commonSmallText, bt.fontWeightNormal)}>
                  <span>{firstName} <FormattedMessage {...messages.willBeRefund} /> {earnedDays > 0 ? '' : 'full'} <FormattedMessage {...messages.reservationCost} /></span>
                </p>
              </div>
            )}
          </div>

          <div className={cx(s.cancellationPolicySec, bt.spaceBottom5)}>
            <div className={cx(bt.commonContentText, bt.fontWeightBold, bt.spaceBottom1)}>
              <span><FormattedMessage {...messages.cancellationPolicy} />:{' '}</span>
              <span><a href={`/cancellation-policies/${encodeURIComponent(defaultPolicyName || policyName)}`} target="_blank" className={bt.siteLinkColor}> {policyName}</a></span>
            </div>
            <div className={cx(bt.commonMediumText, bt.fontWeightNormal, s.cancelPolicyContent)}>
              {policyContent}
            </div>
          </div>
        </div>
      </Col>
    </div>
  );
};

const mapState = (state) => ({
  serviceFees: state.book.serviceFees,
  base: state.currency.base,
  rates: state.currency.rates
});

const mapDispatch = {
  initialize
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(DetailsForHost)));
